import * as React from 'react';
import { IgcGridToolbarExporterComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import type { IgcGridToolbarExporterComponentEventMap } from 'igniteui-webcomponents-grids/grids/index.js';
import { type EventName, createComponent } from '../react-props.js';

/**
 * Provides a pre-configured exporter component for the grid.
 * @fires exportStarted - Emitted when starting an export operation. Re-emitted additionally  by the grid itself.
 * @fires exportEnded - Emitted on successful ending of an export operation.
 * @fires opening - Emits an event before the toggle container is opened.
 * @fires opened - Emits an event after the toggle container is opened.
 * @fires closing - Emits an event before the toggle container is closed.
 * @fires closed - Emits an event after the toggle container is closed.
 * @fires columnToggle - Emits when after a column's checked state is changed
 * @class
 */
export const IgrGridToolbarExporter = /* @__PURE__ */ createComponent({
  tagName: 'igc-grid-toolbar-exporter',
  displayName: 'IgrGridToolbarExporter',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
  events: {
    onExportStarted: 'exportStarted' as EventName<
      IgcGridToolbarExporterComponentEventMap['exportStarted']
    >,
    onExportEnded: 'exportEnded' as EventName<
      IgcGridToolbarExporterComponentEventMap['exportEnded']
    >,
    onOpening: 'opening' as EventName<
      IgcGridToolbarExporterComponentEventMap['opening']
    >,
    onOpened: 'opened' as EventName<
      IgcGridToolbarExporterComponentEventMap['opened']
    >,
    onClosing: 'closing' as EventName<
      IgcGridToolbarExporterComponentEventMap['closing']
    >,
    onClosed: 'closed' as EventName<
      IgcGridToolbarExporterComponentEventMap['closed']
    >,
    onColumnToggle: 'columnToggle' as EventName<
      IgcGridToolbarExporterComponentEventMap['columnToggle']
    >,
  },
});

export type IgrGridToolbarExporter = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrGridToolbarExporterModule = Component;
